__turbopack_context__.v({
  "accordionSlideOverwrite": "header-module-scss-module__demRjW__accordionSlideOverwrite",
  "content": "header-module-scss-module__demRjW__content",
  "demoButton": "header-module-scss-module__demRjW__demoButton",
  "fadeIn": "header-module-scss-module__demRjW__fadeIn",
  "fadeOut": "header-module-scss-module__demRjW__fadeOut",
  "header": "header-module-scss-module__demRjW__header",
  "header__right": "header-module-scss-module__demRjW__header__right",
  "homepageStack": "header-module-scss-module__demRjW__homepageStack",
  "scaleIn": "header-module-scss-module__demRjW__scaleIn",
  "scaleOut": "header-module-scss-module__demRjW__scaleOut",
  "zoomIn": "header-module-scss-module__demRjW__zoomIn",
  "zoomOut": "header-module-scss-module__demRjW__zoomOut",
});
